import { StripeProduct } from '@/modules/billing/models/stripe/StripeProduct';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class StripePrice extends BaseModel {
  public unitAmount: number;

  public product: string | StripeProduct | null;

  constructor(model: Partial<StripePrice> = {}) {
    super();

    this.unitAmount = model.unitAmount as number;
    this.product =
      typeof model.product === 'string'
        ? model.product
        : StripeProduct.mapModelOrNull(model.product);
  }
}
